import React from 'react';
import PropTypes from 'prop-types';
import './PsSpinner.css';

export const PsSpinner = (
    {
        className,
    },
) => {
    return (
        <span className={`ps-spinner ${className}`}/>
    );
};

PsSpinner.propTypes = {
    className: PropTypes.string,
};

PsSpinner.defaultProps = {
    className: '',
};



// WEBPACK FOOTER //
// ./src/app/shared/components/spinner/PsSpinner.jsx